import * as Yup from "yup";
export const messageValidationSchema = Yup.object({
  memberName: Yup.string().required("Member name is required"),
  messageText: Yup.string().required("Message cannot be left empty"),
});
